
// src/firebase/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBi45VLJW7M0-w5_2PPP5VWJjX1e0VojL0",
  authDomain: "nutricionrr-917bc.firebaseapp.com",
  projectId: "nutricionrr-917bc",
  storageBucket: "nutricionrr-917bc.firebasestorage.app",
  messagingSenderId: "658250502191",
  appId: "1:658250502191:web:4c3bbe7d38c531425836da"
};

const app = initializeApp(firebaseConfig);

// 🔹 FIRESTORE
const db = getFirestore(app);

// 🔹 AUTH
const auth = getAuth(app);

// 🔹 PERSISTENCIA (lo que queríamos)
setPersistence(auth, browserLocalPersistence)
  .then(() => console.log("Persistencia activada ✅"))
  .catch((error) => console.error(error));

// 🔥 EXPORTS (CLAVE)
export { db, auth };